import type { IssuedQuoteVersion } from '@repo/api-contracts';

/**
 * 견적 배송지 하나의 배송비 — 발행본의 그 배송지 배송비 줄(`kind: 'SHIPPING'`, `destinationId`) 금액(SUPER-86 spec §7).
 * 짝이 없거나(견적 배송지 id 가 없는 주문 배송지) 그 배송지의 줄이 없으면 null.
 */
export const shippingFeeOf = (
  lines: IssuedQuoteVersion['lines'],
  quoteDestinationId: string | null,
): number | null => {
  if (quoteDestinationId === null) return null;
  const line = lines.find(
    (candidate) => candidate.kind === 'SHIPPING' && candidate.destinationId === quoteDestinationId,
  );
  return line === undefined ? null : line.amount;
};
